import React, { useState } from "react";
import { DragDropUploadPropsTypes } from "./InputGroupType";
import { CloseIcon } from "../iconSet/IconSet";

const MultipleVideoUpload = (props: DragDropUploadPropsTypes) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      props.setFile((prevFiles) => [...prevFiles, ...droppedFiles]);
    }
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      props.setFile((prevFiles) => [...prevFiles, ...selectedFiles]);
    }

    // ✅ allow re-selecting the same file again
    e.target.value = "";
  };

  const handleCloseFile = (index: number) => {
    props.setFile((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="drag-drop-upload-wrapper">
      <span>{props.label}</span>
      <div
        className="drag-drop-upload"
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          backgroundColor: isDragging
            ? "rgba(var(--color-main-black) 0.5)"
            : "var(--color-container-drag-bg)",
        }}
      >
        <p>Drag and drop video files here, or click to select</p>
        <input
          type="file"
          multiple
          onChange={handleFileInput}
          id="videoInput"
          accept="video/*"
          style={{ display: "none" }}
        />
        <label htmlFor="videoInput">Browse Videos</label>

        {props.files.length > 0 && (
          <div
            className="upload-file-wrapper"
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              marginTop: "0.5rem",
              border: "1px solid var(--color-border)",
              padding: "0.5rem",
              borderRadius: "4px",
            }}
          >
            {props.files.map((file, index) => (
              <div
                key={index}
                className="file-item"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                <span>{file.name}</span>
                <div
                  onClick={() => handleCloseFile(index)}
                  style={{ cursor: "pointer", marginLeft: "0.5rem" }}
                >
                  <CloseIcon width="1rem" color="var(--color-main-red)" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultipleVideoUpload;
